import { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

/**
 * The new-design PRIMARY button surface — mango fill, forest label, and the hover/focus treatment
 * that goes with them.
 *
 * Lives here so the <Button variant="PRIMARY" /> case and the hand-rolled controls that must sit
 * beside it as equals (dropdown triggers, which need their own markup for the chevron and the
 * aria-expanded state) share one definition. Recolouring the primary action is then a change here,
 * not a hunt for every button-shaped <button> in the app.
 *
 * Geometry only where it is part of the look: height/width belong to the control's own context
 * (a 40px toolbar button vs a 34px one), so those stay with the consumer.
 */
export const primaryButtonSurface = css`
  border: none;
  border-radius: 8px;
  padding: 0 16px;
  font-weight: 600;
  background-color: ${UiColors.mangoColor};
  color: ${UiColors.forestColor};

  :hover {
    filter: brightness(0.97) saturate(1.15);
  }
  &:focus-visible {
    outline: 2px solid var(--dodger-blue);
    outline-offset: 2px;
  }
`;

export default primaryButtonSurface;
